document.addEventListener('DOMContentLoaded', () => {
	const postcode = document.querySelector('.shipping-calculator input');
	const submit = document.querySelector('.shipping-calculator button');
	const costWrapperPrice = document.querySelector('.shipping-calculator__result .shipping-calculator__result-price');
	const costWrapperPriceVat = document.querySelector('.shipping-calculator__result .shipping-calculator__result-vat-price');

	if (postcode && submit) {
		submit.addEventListener('click', () => {
			if (!postcode.value.length) return;

			submit.classList.add('disabled');

			const data = new FormData();
			const qty = document.querySelector('.qty').value;
			const variation = document.querySelector('.variation_id')
			const product_id = (variation && parseInt(variation.value)) ? variation.value : siteData.postID;

			data.append('action', 'shipping_calculator');
			data.append('postcode', postcode.value);
			data.append('product_id', product_id);
			data.append('qty', qty);

			fetch(siteData.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body: data,
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.message === 'success') {
						submit.classList.remove('disabled');

						/*
						// TODO: no need as same result without condition.
						if (data.data.id === 'outside') {
							costWrapperPrice.innerHTML = data.data.cost_html;
							costWrapperPriceVat.innerHTML = data.data.cost_vat_html;

							return;
						}*/

						costWrapperPrice.innerHTML = data.data.cost_html;
						costWrapperPriceVat.innerHTML = data.data.cost_vat_html;
					}
				})
				.catch((error) => {
					console.error(error);
				});
		});
	}
});
